import request from '@/utils/request.js'
// 获取购物车数量
export function cartCount(data) {
  return request({
    url: '/front/cart/count',
    method: 'GET',
    data: data
  })
}

// 新人手册详情
export function getNewbieInfo(data) {
  return request({
    url: '/front/newbie/getNewbieInfo',
    method: 'GET',
    data: data
  })
}

export function wxJsapiSignature(data) {
  return request({
    url: '/wechat/wxJsapiSignature',
    method: 'GET',
    data: data
  })
}
// 退出登录
export function logout() {
  return request({
    url: '/front/login/logout',
    method: 'post',
  })
}

// 协议
export function agreement(data) {
  return request({
    url: '/front/agreement/accordInfo',
    method: 'GET',
    tips: 'none',
    data: data
  })
}

//微信登录
export function authorizationSessionKeyApi(data) {
  return request({
    url: '/front/wx/miniapp/getSessionKey',
    method: 'post',
    data: {
			...data,
			appid: 'wx8cd8cf567302d088'
		}
  })
}

//获取用户绑定手机号信息
export function getPhone(data) {
  return request({
    url: '/front/wx/miniapp/getPhone',
    method: 'post',
    data: data
  })
}

//登录注册
export function login(data) {
  return request({
    url: '/front/login/login',
    method: 'post',
    data: data
  })
}

//获取验证码
export function verificationCode(data) {
  return request({
    url: '/front/login/verificationCode',
    method: 'post',
    data: data
  })
}

// 获取个人信息
export function centerInfo(data) {
  return request({
    url: '/front/user/center/info',
    method: 'GET',
    data: data
  })
}

// 获取个人中心详情
export function centerNum(data) {
  return request({
    url: '/front/user/center/centerInfo',
    method: 'GET',
    data: data
  })
}

// 推荐商品
export function recommend(data) {
  return request({
    url: '/front/product/recommend/list',
    method: 'GET',
    data: data
  })
}

// 根据分享码获取用户信息
export function getUserInfoByShareCode(data) {
  return request({
    url: '/front/user/getUserInfoByShareCode',
    method: 'POST',
    data: data
  })
}

// 扫码 绑定关系
export function scanBindByShareCode(data) {
  return request({
    url: '/front/user/scanBindByShareCode',
    method: 'POST',
    data: data
  })
}
// 绑定上级 根据上级id 
export function bindByShareUserId(shareUserId) {
  return request({
    url: `/front/user/bindReferrer/${shareUserId}`,
    method: 'GET',
  })
}

// 亲情号-家人邀请
export function familyInvite(data) {
  return request({
    url: '/front/binGuo/family/invite',
    method: 'POST',
    data: data
  })
}

// 好友助力领取槟豆
export function friendsHelp(data) {
  return request({
    url: '/front/binDou/friendsHelp',
    method: 'POST',
    data: data
  })
}

// 实名认证
export function realNameAuthentication(data) {
  return request({
    url: '/front/user/realNameAuthentication',
    method: 'POST',
    data: data
  })
}

// app下载地址
export function getAppDownloadUrl(data) {
  return request({
    url: '/front/login/getAppDownloadUrl',
    method: 'GET',
    data: data
  })
}

// 收藏
export function collectProduct(data) {
  return request({
    url: '/front/collect/product/list',
    method: 'GET',
    data: data
  })
}
